import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 获取待迁移任务列表
export const queryMigrationLogs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMigrationLogs', { ...state.list, loading: true });
    // const res: IPageData = await $http.post(  '/migration/input/log', payload);
    const res: IPageData = await $http.post(  '/v1/migration/input/log', payload);
    commit('setMigrationLogs', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setMigrationLogs', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 获取任务详情(子列表)
export const queryMigrationDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const { uuid, migrationType, success } = payload || {};
    // const postUrl = success
    //   ? `/migration/input/log/${migrationType}/${uuid}`
    //   : `/migration/input/request/${migrationType}/${uuid}`;
    const postUrl = success
      ? `/v1/migration/input/log/${migrationType}/${uuid}`
      : `/v1/migration/input/request/${migrationType}/${uuid}`;
    commit('setMigrationDetail', { ...state.detail, loading: true });
    const res = await $http.get(postUrl, payload);
    commit('setMigrationDetail', { data: res });
  } catch (e) {
    commit('setMigrationDetail', { data: null });
  }
};
